import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { combineLatest, of } from 'rxjs';
import { RunTimeConfigService } from '@shared/services/run-time-config.service';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { LangService } from '@shared/components/lang-bar/lang.service';
@Injectable({
  providedIn: 'root'
})
export class TranslateResolver implements Resolve<any> {
  constructor(
    private _router: Router,
    private runTimeConfigService: RunTimeConfigService,
    private translate: TranslateService,
    private http: HttpClient,
    private langService: LangService
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<unknown> {
    const app = this.runTimeConfigService
      .getConfig('featuresConfig')
      .globalFeatures.apps.find(i => i.app === route.data['app']);

    let translationsPath;
    if (app && app.translationsPath) {
      translationsPath = app.translationsPath;
    }
    translationsPath = translationsPath || route.data['translationsPath'] || null;

    if (translationsPath) {
      const currLanguage = this.langService.getCurrentLanguage().languageCode;

      if (Array.isArray(translationsPath) && translationsPath.length > 0) {
        const APIs = [];
        for (const tPath of translationsPath) {
          APIs.push(
            this.http.get(tPath + '/' + currLanguage + '.json').pipe(
              map((translations: any) => {
                this.translate.setTranslation(currLanguage, translations, true);
              })
            )
          );
        }
        return combineLatest(APIs).toPromise();
      } else {
        const translationFilePath = translationsPath + '/' + currLanguage + '.json';
        return this.http
          .get(translationFilePath)
          .pipe(
            map((translations: any) => {
              this.translate.setTranslation(currLanguage, translations, false);
            })
          )
          .toPromise();
      }
    } else {
      return of({}).toPromise();
    }
  }
}
